/**
 * Les mots de la page Autoriser (chantier connecteur-claude, ticket 02) : Claude demande l'accès
 * au compte, l'utilisateur autorise ou refuse. Ce que Claude pourra faire suit les outils du MCP
 * (décision 5 du cadrage) : lire, créer, modifier, cocher, jamais supprimer.
 */

export const CLAUDE_VEUT_ACCEDER = 'Claude veut accéder à tes projets';
export const bonjour = (qui: string | null) => (qui ? `Bonjour ${qui}.` : 'Bonjour.');
export const CE_QUE_CLAUDE_POURRA_FAIRE = 'Ce que Claude pourra faire :';
export const CE_QUE_CLAUDE_FERA: readonly string[] = [
  'Lire tes projets, tes bulles, ce que tu peux faire maintenant et ton agenda',
  'Créer des bulles et des projets',
  'Modifier tes bulles, les déplacer, les mettre dans l’ordre',
  'Les cocher, et défaire une coche',
  'Préparer tes journées',
];
export const JAMAIS_SUPPRIMER = 'Jamais supprimer : aucune bulle ne part par Claude.';
export const tuReviendrasSur = (hote: string) => `Tu reviendras ensuite sur ${hote}.`;
export const RETOUR_LOCAL =
  'Le retour se fait sur cet ordinateur (Claude Code). Autorise seulement si c’est toi qui viens de le demander.';
export const ON_COUPE_DANS_PARAMETRES = 'Tu pourras couper cet accès dans Paramètres.';
export const AUTORISER = 'Autoriser';
export const REFUSER = 'Refuser';
export const REESSAYER = 'Réessayer';
export const DEMANDE_QUI_NE_VAUT_PLUS = 'Cette demande ne vaut plus';
export const RECOMMENCE_DEPUIS_CLAUDE = 'Elle a dépassé son temps, ou elle a déjà servi. Recommence depuis Claude.';
